module.exports = __webpack_public_path__ + "static/img/yk6110.9bba7ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk6110.png
// module id = DhxP
// module chunks = 1